import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { WorkerService } from 'src/app/data/worker.service';
import { WorkerFormDocumentStatementDto } from 'src/app/models/dtos/WorkerFormDocumentStatementDto';
import { WorkerFileDto } from 'src/app/models/worker-file-dto';
import { WorkerProfile } from 'src/app/models/WorkerProfile';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { Messages } from 'src/app/common/enums/messages';

export interface AddFileModalData {
  WorkerProfile: WorkerProfile;
  DocumentStatement: WorkerFormDocumentStatementDto;
  QuestionText: string;
}

@Component({
  selector: 'app-add-file-modal',
  templateUrl: './add-file-modal.component.html',
  styleUrls: ['./add-file-modal.component.scss'],
  standalone: false
})
export class AddFileModalComponent {
  dialogRef = inject<MatDialogRef<AddFileModalComponent>>(MatDialogRef);
  data = inject<AddFileModalData>(MAT_DIALOG_DATA);
  private workerService = inject(WorkerService);
  private spinner = inject(NgxSpinnerService);
  private snackBarService = inject(SnackBarService);

  isFileUploaded: boolean = false;
  private files: File[];
  private result: WorkerFileDto[] = [];

  readonly maxFileCount = 5;

  constructor() { }

  onFilesChange(files: File[]) {
    this.result = [];
    this.files = files;
    this.isFileUploaded = !!this.files;

    this.files.forEach((element) => {
      let file = new WorkerFileDto();
      file.OriginalName = element.name;
      file.WorkerFileTypeId = this.data.DocumentStatement.AttachmentTypeId;
      file.WorkerId = this.data.WorkerProfile.WorkerId;
      file.Description = null;
      let reader = new FileReader();
      reader.onload = () => {
        // Store base64 encoded representation of file
        file.FileContent = reader.result.toString();
        this.result.push(file);
      };

      // Read the file
      reader.readAsDataURL(element);
    });
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSave() {
    this.spinner.show();

    this.workerService
      .saveWorkerFiles(this.result)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        }),
      )
      .subscribe((response) => {
        if (response?.IsPendingVerification) {
          this.snackBarService.openSuccessSnackBar(Messages.WorkerFilePendingVerification);
        }
        this.files = [];
        this.dialogRef.close(true);
      });
  }
}
